import React, { Component } from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Grid from "@material-ui/core/Grid";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import FormControl from "@material-ui/core/FormControl";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import Datetime from "react-datetime";
import AlertList from "granular/Alert/alertList.js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { pushLoader } from "../../actions/main";

import {
  fetchAlert,
  fetchAlertAll,
  pushAlert,
  deleteAlert,
  updateAlert
} from "../../api/alert";

import moment from "moment";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const styles = theme => ({
  title: {
    textAlign: "center",
    flex: 1,
    fontSize: "32px",
    fontWeight: 500
  }
});

class Alerts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateAlert: "",
      company_code: "",
      title: "",
      description: "",
      userlevel: localStorage.getItem("userlevel"),
      datatable: [],
      openAdd: false,
      openEdit: false,
      id: 0,
      loader: null
    };
  }

  componentDidMount() {
    this.getDatatable();
  }

  restate = args => {
    this.setState({
      id: args[0],
      company_code: args[1],
      title: args[2],
      description: args[3],
      userlevel: args[4],
      dateAlert: args[5],
      openEdit: true
    });
  };

  updating = () => {
    updateAlert(this.state)
      .then(response => {
        if (response != null) {
          this.getDatatable();
          this.setState({
            dateAlert: "",
            company_code: "",
            title: "",
            description: "",
            userlevel: localStorage.getItem("userlevel"),
            openEdit: false
          });
        }
      })
      .catch(error => {
        console.log("tidak berhasil");
        this.props.history.push("/pages/login#logout");
      });
  };

  getDatatable = () => {
    this.props.pushLoader(true)
    this.setState({loader: true})
    fetchAlertAll()
      .then(response => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
        this.props.pushLoader(false)
        this.setState({loader: false})
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  handleDelete = id => {
    deleteAlert(id)
      .then(response => {
        if (response != null) {
          this.getDatatable();
        }
      })
      .catch(error => {
        console.log("tidak berhasil");
        this.props.history.push("/pages/login#logout");
      });
  };

  handleClose = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  handleChangedateAlert = event => {
    //console.log(moment(event._d).format("YYYY-MM-DD kk:mm:ss"));
    this.setState({ dateAlert: moment(event._d).format("YYYY-MM-DD") });
  };

  handleSubmit = () => {
    pushAlert(this.state)
      .then(response => {
        if (response != null) {
          this.getDatatable();
          this.setState({
            company_code: "",
            title: "",
            description: "",
            userlevel: localStorage.getItem("userlevel"),
            dateAlert: "",
            openAdd: false
          });
        }
      })
      .catch(error => {
        console.log("tidak berhasil");
        this.props.history.push("/pages/login#logout");
      });
  };

  handleChangeText = (keys, e) => {
    this.setState({ [keys]: e.target.value });
  };

  render() {
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ justifyContent: "center" }}>
            <Typography className={classes.title}>Alert</Typography>
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="info"
              value={100}
              style={{ width: "20%", display: "inline-block" }}
            />
            <CustomLinearProgress
              variant="determinate"
              color="gray"
              value={0}
              style={{ width: "40%", display: "inline-block" }}
            />
          </div>
        </GridItem>
        <Grid item xs={12}>
          <Grid container justify="center" spacing={2}>
            <GridItem xs={10} sm={10} md={10}>
              <Card>
                <CardHeader color="rose" icon>
                  <Button
                    color="success"
                    round
                    onClick={() => this.handleClose("openAdd", true)}
                  >
                    Add Alert
                  </Button>
                </CardHeader>
                <AlertList
                  datatable={this.state.datatable}
                  handleDelete={this.handleDelete}
                  restate={this.restate}
                  loader={this.state.loader}
                />
              </Card>
              <Dialog
                fullScreen
                open={this.state.openAdd}
                onClose={() => this.handleClose("openAdd", false)}
                aria-labelledby="form-dialog-title"
              >
                <DialogTitle id="form-dialog-title">Add Alert</DialogTitle>
                <DialogContent>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Company Code"
                        id="company_code"
                        inputProps={{
                          value: this.state.company_code,
                          onChange: e =>
                            this.handleChangeText("company_code", e)
                        }}
                        formControlProps={{
                          fullWidth: true
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Title"
                        id="title"
                        inputProps={{
                          value: this.state.title,
                          onChange: e => this.handleChangeText("title", e)
                        }}
                        formControlProps={{
                          fullWidth: true
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Description"
                        id="description"
                        inputProps={{
                          value: this.state.description,
                          onChange: e => this.handleChangeText("description", e)
                        }}
                        formControlProps={{
                          fullWidth: true
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="User Level"
                        id="userlevel"
                        inputProps={{
                          value: this.state.userlevel,
                          onChange: e => this.handleChangeText("userlevel", e)
                        }}
                        formControlProps={{
                          fullWidth: true
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <InputLabel>Date Alert</InputLabel>
                      <br />
                      <FormControl fullWidth>
                        <Datetime
                          timeFormat={false}
                          dateFormat="LL"
                          onChange={this.handleChangedateAlert}
                          inputProps={{
                            placeholder: "Date Picker Here"
                          }}
                          value={this.state.dateAlert}
                        />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => this.handleClose("openAdd", false)}
                    color="default"
                    round
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => this.handleSubmit()}
                    color="success"
                    round
                  >
                    Add
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                fullScreen
                open={this.state.openEdit}
                onClose={() => this.handleClose("openEdit", false)}
                aria-labelledby="form-dialog-title"
              >
                <DialogTitle id="form-dialog-title">Update Alert</DialogTitle>
                <DialogContent>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Company Code"
                        id="company_code"
                        inputProps={{
                          value: this.state.company_code,
                          onChange: e =>
                            this.handleChangeText("company_code", e)
                        }}
                        formControlProps={{
                          fullWidth: true
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Description"
                        id="description"
                        inputProps={{
                          value: this.state.description,
                          onChange: e => this.handleChangeText("description", e)
                        }}
                        formControlProps={{
                          fullWidth: true
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="User Level"
                        id="userlevel"
                        inputProps={{
                          value: this.state.userlevel,
                          onChange: e => this.handleChangeText("userlevel", e)
                        }}
                        formControlProps={{
                          fullWidth: true
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <InputLabel>Date Alert</InputLabel>
                      <br />
                      <FormControl fullWidth>
                        <Datetime
                          timeFormat={false}
                          dateFormat="LL"
                          onChange={this.handleChangedateAlert}
                          inputProps={{
                            placeholder: "Date Picker Here"
                          }}
                          value={this.state.dateAlert}
                        />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => this.handleClose("openEdit", false)}
                    color="default"
                    round
                  >
                    Cancel
                  </Button>
                  <Button onClick={() => this.updating()} color="success" round>
                    Update
                  </Button>
                </DialogActions>
              </Dialog>
            </GridItem>
          </Grid>
        </Grid>
      </GridContainer>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default withRouter(connect(mapStateToProps, {pushLoader})(withStyles(styles)(Alerts)));
